import SearchSuggestions from './SearchSuggestions';

export default SearchSuggestions;
